import { useState } from "react";
import moment from "moment";
import { startOfMonth } from "date-fns";
import { Box, Button, Typography } from "@material-ui/core";
import { People } from "@material-ui/icons";
import { useUserProfile } from "@hooks";
import { DatePicker } from "@bonliva-crm/ui";
import { useGlobalUserSelector, UserSelectorItem } from "@containers/user-selector-modal";
import { UserStats } from "./user-stats";
import { TeamStats } from "./team-stats";
import { useLocale } from "@hooks";

export function ConsultantOpportunityStats() {
  const { locale } = useLocale();
  const [date, setDate] = useState(moment().startOf("month").toDate());
  const userProfile = useUserProfile();
  const { select } = useGlobalUserSelector();
  const [user, setUser] = useState<UserSelectorItem>(userProfile.myProfile);

  const handleSelectUser = () => {
    select({ multi: false }).then((selected) => {
      if (selected.length > 0) {
        setUser(selected[0]);
      }
    });
  };

  const offset = moment().utcOffset();
  const start = moment(date).add(offset, "minutes").toDate();
  const end = moment(date).add(1, "month").add(offset, "minutes").toDate();

  const teams = user.Teams.filter((x) => x !== "Jour");

  return (
    <Box style={{ paddingLeft: "1rem" }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Box>
            <Typography variant="h5">Statistik</Typography>
          </Box>

          <Box ml={2}>
            <Button
              startIcon={<People />}
              variant="outlined"
              onClick={() => handleSelectUser()}
            >
              {locale.switchUserBoard}
            </Button>
          </Box>
        </Box>

        <Box display="flex">
          <Box display="flex" p={1} width="20rem">
            <DatePicker
              fullWidth
              value={date}
              onChange={(d) => setDate(startOfMonth(d || new Date()))}
              label=""
              DatePickerProps={{
                showMonthYearPicker: true,
                dateFormat: "MMM yyyy"
              }}
            />
          </Box>
        </Box>
      </Box>

      <UserStats start={start} end={end} userId={user._id} userName={user.Name} />

      {teams.map((team) => (
        <Box mt={8}>
          <TeamStats key={team} team={team} start={start} end={end} />
        </Box>
      ))}
    </Box>
  );
}
